export const SET_FLOATING_BUTTON = 'SET_FLOATING_BUTTON';
export const SET_WAIT_CURSOR = 'SET_WAIT_CURSOR';
export const SET_IMAGE_WRAPPER = 'SET_IMAGE_WRAPPER';
export const SET_VIDEO_WRAPPER = 'SET_VIDEO_WRAPPER';
